export function fieldToNetworkField(field, index) {
    return {
        index: index,
        name: field.name,
        alias: field.alias,
        description: null,
        type: field.type,
        native: field.native !== undefined ? field.native : null,
        visible: field.visible,
        business_type: null,
    };
}
//# sourceMappingURL=field.js.map